var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _value, _listeners, _removeLister, removeLister_fn;
class ValueStore {
  constructor(initialValue) {
    __privateAdd(this, _removeLister);
    __privateAdd(this, _value, void 0);
    __privateAdd(this, _listeners, /* @__PURE__ */ new Set());
    __privateSet(this, _value, initialValue);
  }
  get() {
    return __privateGet(this, _value);
  }
  set(newValue) {
    if (__privateGet(this, _value) !== newValue) {
      __privateSet(this, _value, newValue);
      for (const listener of __privateGet(this, _listeners))
        listener(__privateGet(this, _value));
    }
  }
  onChange(listener) {
    __privateGet(this, _listeners).add(listener);
    return __privateMethod(this, _removeLister, removeLister_fn).bind(this, listener);
  }
}
_value = new WeakMap();
_listeners = new WeakMap();
_removeLister = new WeakSet();
removeLister_fn = function(listener) {
  __privateGet(this, _listeners).delete(listener);
};

export { ValueStore as default };
//# sourceMappingURL=ValueStore.js.map
